export default __webpack_public_path__ + "static/media/circle_loader.096329e8.gif";